<template lang="pug" src='./modal.pug'></template>

<script>
import { closeModal, showModal, moveTo, toggleMenu, goToPayments } from '@/mixins'
import Form from 'components/form/form'
import Icon from 'components/icon/icon'

export default {
  props: [ 'props' ],
  created () {
    console.log(this)
  },
  mixins: [ closeModal, showModal, moveTo, toggleMenu, goToPayments ],
  components: {
    Form,
    Icon
  },
  computed: {
    screenIsMobile () {
      return window.innerWidth < 880
    }
  }
}
</script>



// WEBPACK FOOTER //
// modal.vue?6efb5b7a